import React, { useState, useEffect } from 'react';
import { Alert } from '@mui/material';

const STORAGE_KEY = 'quantato_risk_banner_dismissed';

const RiskDisclosureBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    setDismissed(stored === 'true');
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  if (dismissed) return null;

  return (
    <Alert
      severity="warning"
      onClose={handleDismiss}
      sx={{
        mb: 2,
        backgroundColor: 'rgba(232,160,69,0.1)',
        color: '#4A3728',
        border: '1px solid rgba(232,160,69,0.3)',
        '& .MuiAlert-icon': {
          color: '#E8A045',
        },
        '& .MuiAlert-action .MuiIconButton-root': {
          color: '#7A5F4E',
        },
      }}
    >
      Prediction market trading involves risk of loss. Backtest results do not guarantee future
      performance. Trade responsibly.
    </Alert>
  );
};

export default RiskDisclosureBanner;
